<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm fromData"
      label-position="left"
    >
      <el-form-item label="设备名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="吸合动作名称" prop="onname">
        <el-input v-model="ruleForm.onname"></el-input>
      </el-form-item>
      <el-form-item label="断开动作名称" prop="offname">
        <el-input v-model="ruleForm.offname"></el-input>
      </el-form-item>
      <el-form-item label="是否检测行程量">
        <div style="display:flex">
          <el-checkbox v-model="ruleForm.Istrip" :true-label="'1'" :false-label="'0'"></el-checkbox>
          <el-input v-model="ruleForm.name" style="visibility:hidden;"></el-input>
        </div>
      </el-form-item>
      <el-form-item
        label="上传继电器1开启动画"
        prop="opengif1"
        label-width="153px"
        v-if="ruleForm.Istrip == 1"
        :class="{filenduser:hasFmt}"
      >
        <el-upload
          action="#"
          :file-list="fileData"
          list-type="picture-card"
          :auto-upload="false"
          :on-preview="handlePictureCardPreview"
          :on-change="fileCHnads"
          :on-remove="handleRemove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible"  :modal="false" title="图片">
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
      </el-form-item>
      <el-form-item
        label="上传继电器2开启动画"
        prop="opengif2"
        label-width="155px"
        v-if="ruleForm.Istrip == 1"
      >
        <el-upload
          action="#"
          :show-file-list="true"
          list-type="picture-card"
          :auto-upload="false"
          :file-list="fileDataTow"
          :on-preview="handlePictureCardPreview"
          :on-change="fileCHnadsTow"
          :on-remove="handleRemoveFind"
          :class="{filenFut:hasTwo}"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible"  :modal="false"  title="图片">
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
      </el-form-item>
      <el-form-item label="上传开启状态图片" prop="openpic" label-width="155px">
      <!--   -->
        <el-upload
          action="#"
          list-type="picture-card"
          :auto-upload="false"
          :on-preview="handlePictureCardPreview"
          :show-file-list="hasThree"
          :file-list="fileDataThree"
          :on-change="fileCHnadsThree"
          :on-remove="handleRemoveThrd"
         :class="{filenImgs:hasThree}"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible"  :modal="false"  title="图片">
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
      </el-form-item>
      <el-form-item label="上传关闭状态图片" prop="closepic" label-width="155px">
        <el-upload
          action="#"
          :show-file-list="true"
          list-type="picture-card"
          :auto-upload="false"
          :file-list="fileDatafIND"
          :on-preview="handlePictureCardPreview"
          :on-change="fileCHnadsFirlt"
          :on-remove="handleRemoveFirt"
          :class="{filenClone:valiIconFile}"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible"  :modal="false"  title="图片">
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
      </el-form-item>
      <el-form-item
        label="上传中间状态图片"
        prop="supspendpic"
        label-width="155px"
        v-if="ruleForm.Istrip == 1"
      >
        <el-upload
          action="#"
          :show-file-list="true"
          list-type="picture-card"
          :auto-upload="false"
          :file-list="fileDataUrlimg"
          :on-preview="handlePictureCardPreview"
          :on-change="fileCHnadsSize"
          :on-remove="handleRemoveZIE"
          :class="{filenZhong:valiIconSize}"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible"  :modal="false"  title="图片">
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
      </el-form-item>
       <el-form-item
        label="上传中间状态图片"
        prop="supspendpic"
        label-width="335px"
       style="visibility: hidden;"
      >
       
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer forDataInfoCentent">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="congingInft">保存</el-button>
    </span>
    {{handData}}
    {{handIMGt}}
    {{handCONgf}}
    {{handFonf}}
    {{handIMGconfing}}
  </div>
</template>

<script>
import fileDellow from "../../../assets/js/file";
import { AddHnnds } from "@/network/lineRequest";

export default {
  props: {
    postjsonData: {
      type: Function,
      default: null,
    },
    ruleForm: {
      type: Object,
      default: {},
    },
    updatehand: {
      type: Function,
      default: null,
    },
  },
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      if (!this.hasFmt) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    var valiIconTwo = (rule, value, callback) => {
      // 图片验证
      if (!this.hasTwo) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    var valiIconThree = (rule, value, callback) => {
      // 图片验证
      if (!this.hasThree) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    var valiIconFile = (rule, value, callback) => {
      // 图片验证
      if (!this.valiIconFile) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    var valiIconSize = (rule, value, callback) => {
      // 图片验证
      if (!this.valiIconSize) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    return {
      hasFmt: false,
      hasTwo: false,
      hasThree: false,
      valiIconFile: false,
      valiIconSize: false,
      fileData: [], //1
      fileDataTow: [], //2
      fileDataThree: [], //3
      fileDatafIND: [], //4
      fileDataUrlimg: [], //5
      dialogImageUrl: "",
      dialogVisible: false,
      rules: {
        name: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        offname: [
          { required: true, message: "请输入断开动作名称", trigger: "blur" },
        ],
        onname: [
          { required: true, message: "请输入吸合动作名称", trigger: "blur" },
        ],
        opengif1: [
          { required: true, validator: valiIcon, trigger: "change" }, // 图片验证
        ],
        opengif2: [
          { required: true, validator: valiIconTwo, trigger: "change" }, // 图片验证
        ],
        openpic: [
          { required: true, validator: valiIconThree, trigger: "change" }, // 图片验证
        ],
        closepic: [
          { required: true, validator: valiIconFile, trigger: "change" }, // 图片验证
        ],
        supspendpic: [
          { required: true, validator: valiIconSize, trigger: "change" }, // 图片验证
        ],
      },
    };
  },
  computed: {
    handData() {
      if (
        this.ruleForm.openpic != "" &&
        this.ruleForm.openpic != null &&
        this.ruleForm.uuid != undefined
      ) {
        this.hasThree = true;
        this.fileDataThree.push({
          url: this.ruleForm.openpic,
        });
      }else{
          // this.hasThree = false
      }
    },
    // 关闭
    handIMGt() {
      if (
        this.ruleForm.closepic != "" &&
        this.ruleForm.closepic != null &&
        this.ruleForm.uuid != undefined
      ) {
        this.valiIconFile = true;
        this.fileDatafIND.push({
          url: this.ruleForm.closepic,
        });
      }else{
          // this.valiIconFile = false
      }
    },
    // opengif1
    handCONgf() {
      if (
        this.ruleForm.opengif1 != "" &&
        this.ruleForm.opengif1 != null &&
        this.ruleForm.uuid != undefined
      ) {
        this.hasFmt = true;
        this.fileData.push({
          url: this.ruleForm.opengif1,
        });
      }else{
          // this.hasFmt = false
      }
    },
    // opengif2
    handFonf() {
      if (
        this.ruleForm.opengif2 != "" &&
        this.ruleForm.opengif2 != null &&
        this.ruleForm.uuid != undefined
      ) {
        this.hasTwo = true;
        this.fileDataTow.push({
          url: this.ruleForm.opengif2,
        });
      }else{
          // this.hasTwo = false
      }
    },
    handIMGconfing() {
      if (
        this.ruleForm.supspendpic != "" &&
        this.ruleForm.supspendpic != null &&
        this.ruleForm.uuid != undefined
      ) {
        this.valiIconSize = true;
        this.fileDataUrlimg.push({
          url: this.ruleForm.supspendpic,
        });
      }else{
          // this.valiIconSize = false
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.updatehand();
      this.showThend()
      this.cloneFedts();
    },
    // 验证方法
    congingInft() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const { code, data, msg } = await AddHnnds(this.ruleForm);
          if (code) {
            this.postjsonData();
            this.cloneFedts();
            this.updatehand();
            this.showThend()
            this.$message.success(msg);
          } else {
            this.$message.error(msg);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 清空下图片
    cloneFedts() {
      this.fileData = []; //1
      this.fileDataTow = []; //2
      this.fileDataThree = []; //3
      this.fileDatafIND = []; //4
      this.fileDataUrlimg = []; //5
    },
    // 上传继电器1开启动画
    async fileCHnads(file, fiNdn) {
      let fileData = {
        file: file.raw,
      };
      this.DellowFile(fileData, 1);
      this.hasFmt = fiNdn.length > 0 ? true : false;
    },
    // 上传继电器2开启动画
    fileCHnadsTow(file, fiNdn) {
      let fileData = {
        file: file.raw,
      };
      this.DellowFile(fileData, 2);
      this.hasTwo = fiNdn.length > 0 ? true : false;
    },
    // 上传开启状态图片
    fileCHnadsThree(file, fiNdn) {
      let fileData = {
        file: file.raw,
      };
      this.DellowFile(fileData, 3);
      this.hasThree = fiNdn.length > 0 ? true : false;
    },
    //上传关闭状态图片
    fileCHnadsFirlt(file, fiNdn) {
      let fileData = {
        file: file.raw,
      };
      this.DellowFile(fileData, 4);
      this.valiIconFile = fiNdn.length > 0 ? true : false;
    },
    fileCHnadsSize(file, fiNdn) {
      let fileData = {
        file: file.raw,
      };
      this.DellowFile(fileData, 5);
      this.valiIconSize = fiNdn.length > 0 ? true : false;
    },
    // 公共下载方法
    async DellowFile(fileData, index) {
      // console.log(index);

      const res = await fileDellow(fileData);
      if (this.ruleForm.uuid == undefined) {
      }
      switch (index) {
        case 1:
          this.fileData = [];
          this.ruleForm.opengif1 = res; //开启动图
          if (this.ruleForm.uuid == undefined) {
            this.fileData.push({
              url: res,
            });
          }
          return;
        case 2:
          this.fileDataTow = [];
          this.ruleForm.opengif2 = res; //开启动图
          if (this.ruleForm.uuid == undefined) {
            this.fileDataTow.push({
              url: res,
            });
          }
          return;
        case 3:
          this.fileDataThree = [];
          this.ruleForm.openpic = res; //上传开启状态图片
          if (this.ruleForm.uuid == undefined) {
            this.fileDataThree.push({
              url: res,
            });
          }
          return;
        case 4:
          this.fileDatafIND = [];
          this.ruleForm.closepic = res; //上传关闭状态图片
          if (this.ruleForm.uuid == undefined) {
            this.fileDatafIND.push({
              url: res,
            });
          }
          return;
        case 5:
          this.fileDataUrlimg = [];
          this.ruleForm.supspendpic = res; //中间挂起静图
          if (this.ruleForm.uuid == undefined) {
            this.fileDataUrlimg.push({
              url: res,
            });
          }

          return;
      }
    },
    // 新增显示图片
    showThend() {
      this.hasFmt = false;
      this.hasTwo = false;
      this.hasThree = false;
      this.valiIconFile = false;
      this.valiIconSize = false;
    },
    handleRemove(file, fileList) {
      this.hasFmt = false;
    },
    handleRemoveFind() {
      this.hasTwo = false;
    },
    handleRemoveThrd() {
      this.hasThree = false;
    },
    handleRemoveFirt() {
      this.valiIconFile = false;
    },
    handleRemoveZIE() {
      this.valiIconSize = false;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>

<style  lang="scss">
.filenduser .el-upload--picture-card {
  display: none;
}
.filenFut .el-upload--picture-card {
  display: none;
}
.filenImgs .el-upload--picture-card {
  display: none;
}
.filenClone .el-upload--picture-card {
  display: none;
}
.filenZhong .el-upload--picture-card {
  display: none;
}
.forDataInfoCentent{
  display: flex;
  justify-content: center;
  padding-top: 20px ;
}
.fromData {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

}
</style>
